import { useState, useEffect } from "react";

import alertMessage from "../../utilities/alertMessage";
import RenderHtmlText from "../../utilities/renderhtmltext";
import Review from "../helpers/review";
import AvatarWithAudio from "../../utilities/avatars/avatarWithAudio";
import AssessmentRecord from "../helpers/assessmentRecord";
import LoadingBasic from "../../utilities/loadingbasic";


function ReadPassage(props) {

  // Define variables
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('record'); // record, review
  const [retryCount, setRetryCount] = useState(0);
  const [responseData, setResponseData] = useState({});
  const cefrLevel = props.cefrLevel;
  const passage = props.passage;
  const instructionRecord = props.instructionRecord;
  const instructionExtra = props.instructionExtra;
  const instructionReview = props.instructionReview;
  const timerSpeak = props.timerSpeak;
  const timerReview = props.timerReview;
  const nextAction = props.nextAction;
  const retryPossible = props.retryPossible;
  const scoreType = props.scoreType;


  // Component load actions
  useEffect(() => {

    setLoading(true);
    setStatus('record');
    setResponseData({});
    setRetryCount(0);

    if( passage ) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }

  }, [passage]);


  // Define functions
  function handleTranscript(responseObject) {
    if( responseObject.success ) {

      // Add the retry count
      responseObject.retryCount = retryCount;

      // Add the passage id
      responseObject.passageId = passage.id;

      // If Opinion,
      // Ensure the learner did not repeat the question
      if( scoreType === 'conversation' ) {
        const repeatedText = checkForRepeat(responseObject, passage.text);

        if( repeatedText ) {
          cleanRetry();
          return;
        }
      }

      setResponseData(responseObject);
      setStatus('review');
    } else {
      if( responseObject.error === 1001 ) {

        // Handle empty object
        const emptyObject = {
          success: true,
          learnerDidNotRecord: true,
        }

        setResponseData(emptyObject);
        setStatus('review');

      } else {
        reportError(`Assessment Read error: ${JSON.stringify(responseObject)}`);
        alertMessage('Sorry, there was an error. Please contact support@flowspeak.io for assistance.');
      }
    }
  }

  function cleanRetry() {
    setStatus(' ');
    setResponseData({});

    setTimeout(() => {
      setStatus('record');
    }, 1000);

    alertMessage('Tip - answer the question directly without repeating it.', 'error');
  }

  function retry() {
    setStatus('record');
    setResponseData({});
    setRetryCount(1);
  }


  // Screen components
  let passageContent = <LoadingBasic />;
  let actionContent;

  if( !loading ) {

    passageContent = (
      <div class='flex-column assess-passage-container'>
        <AvatarWithAudio
          type='assistant'
          avatarUrl={passage.iconUrl}
          audioUrl={passage.audioUrl}
        />
        <br />
        <RenderHtmlText string={passage.text} />
      </div>
    );

    if( status === 'record' ) {

      let instructionExtraElement;
      if( instructionExtra ) {
        instructionExtraElement = <div style={{marginTop: '5px'}}><RenderHtmlText string={instructionExtra} /></div>;
      }

      const messages = [{
        role: "assistant",
        content: passage.text
      }]

      actionContent = (
        <div class='flex-column assess-record-container'>
          <p class='assess-fancy small'>{instructionRecord}</p>
          {instructionExtraElement}
          <AssessmentRecord
            messages={messages}
            handleTranscript={handleTranscript}
            providedText={passage.text}
            scoreType={scoreType}
            seconds={timerSpeak}
            extras={{cefrLevel: cefrLevel, toneLearner: 'professional'}}
          />
        </div>
      )

    } else if( status === 'review' ) {
      actionContent = (
        <Review
          instruction={instructionReview}
          audioUrl={responseData.audioUrl}
          buttonFunction={() => nextAction(responseData)}
          seconds={timerReview}
          retryCount={retryCount}
          retryPossible={retryPossible}
          retry={retry}
        />
      );
    }
  }


  return (
    <>
      <div class='flex-column assess-glass'>
        {passageContent}
        {actionContent}
      </div>
    </>
  );
}

export default ReadPassage;




function checkForRepeat(responseObject, passage) {
  let repeatedText = false;

  if( responseObject?.scoreTwo?.transcript ) {
    const passageText = passage.replace(/[^\w\s\']|_/g, "").replace(/\s+/g, " ").replace(/'/g, '').toLowerCase();
    const transcript = responseObject.scoreTwo.transcript.replace(/[^\w\s\']|_/g, "").replace(/\s+/g, " ").replace(/'/g, '').toLowerCase();

    if( transcript === passageText ) {
      repeatedText = true;
    }

  }

  return repeatedText;
}